var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.325 8.30861C24.325 8.30861 21.67 7.97461 15.968 7.97461C10.451 7.97461 7.674 8.30861 7.674 8.30861C6.96472 8.30887 6.28458 8.59082 5.78314 9.09245C5.28169 9.59408 5 10.2743 5 10.9836V21.0176C4.99987 21.3689 5.06893 21.7168 5.20324 22.0414C5.33755 22.366 5.53448 22.6609 5.78278 22.9094C6.03109 23.1579 6.3259 23.3551 6.6504 23.4896C6.97489 23.6242 7.32271 23.6935 7.674 23.6936C7.674 23.6936 10.256 24.0256 15.968 24.0256C21.677 24.0256 24.325 23.6936 24.325 23.6936C24.6764 23.6939 25.0245 23.6248 25.3492 23.4904C25.674 23.356 25.969 23.1589 26.2175 22.9104C26.4659 22.6618 26.6629 22.3667 26.7972 22.0419C26.9315 21.7171 27.0004 21.3691 27 21.0176V10.9816C27 10.6304 26.9308 10.2827 26.7963 9.95823C26.6619 9.6338 26.4648 9.33904 26.2164 9.09081C25.968 8.84257 25.6731 8.64572 25.3485 8.51151C25.024 8.37729 24.6762 8.30835 24.325 8.30861ZM13.061 19.9746V12.0296L20.195 15.9996L13.061 19.9746Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.8920ee9d2585891af7feb572a16e9f93.svg";
export { ForwardRef as ReactComponent };